import React from 'react'
import { Panel, Card, TextFieldIcon } from '../../../_components'
import { useDispatch, useSelector } from 'react-redux'
import { setDisplayModal, removePurchaseItem } from '../../../_slices/AppSlice'
import { formatCurrency } from '../../../_utils'

export default function SectionF( { handleChange, handleBlur, values } ) {
  const dispatch = useDispatch()
  const state = useSelector( state => {
    return {
      title: state.application.displayModal?.title,
      flag: state.application.displayModal?.flag,
      purchaseTools: state.application.purchaseTools
    }
  } )

  const handleDeleteItem = async ( idx ) => {
    await dispatch( removePurchaseItem( { idx } ) )
  }

  return (
    <Card title="Amount Paid for Water User Fees">
      <Panel label="Section F: Water User Fees">
        <div className="grid grid-cols-1">
            <table className="w-full border">
              <thead className="text-xs bg-gray-200 font-bold p-2 uppercase">
                  <th>{`Item`}</th>
                  <th>{`Amount`}</th>
              </thead>
              <tbody>
                 <tr>
                    <td className="text-start">{`Water User Fees`}</td>
                    <td className="text-start">
                        <TextFieldIcon 
                            name="water_fees"
                            type="number"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.water_fees}
                            label="Amount(UGX)"
                            disabled={false}
                            required={true}
                            question="Water User Fees(UGX)"
                        />
                    </td>
                 </tr>
              </tbody>
            </table>
        </div>
      </Panel>

      <Panel label="Section G: Harvested Rice(Unmilled )">
        <div className="grid grid-cols-1">
            <table className="w-full border">
              <thead className="text-xs bg-gray-200 font-bold p-2 uppercase">
                  <th>{`Item`}</th>
                  <th>{`Amount`}</th>
              </thead>
              <tbody>
                 <tr>
                    <td className="text-start">{`Harvested Rice(Unmilled)`}</td>
                    <td className="text-start">
                        <TextFieldIcon 
                            name="harvested_rice"
                            type="number"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.harvested_rice}
                            label="Total(Kgs)"
                            disabled={false}
                            required={true}
                            question="Harvested Rice( UnMilled)(Kgs)"
                        />
                    </td>
                 </tr>
              </tbody>
            </table>
        </div>
      </Panel>
      
      <Panel label="Section H: Rice Sold">
        <div className="grid grid-cols-1">
            <table className="w-full border">
              <thead className="text-xs bg-gray-200 font-bold p-2 uppercase">
                  <th>{`Season`}</th>
                  <th>{`Category`}</th>
                  <th>{`Qty`}</th>
                  <th>{`Rate`}</th>
                  <th>{`Amount`}</th>
              </thead>
              <tbody>
                <tr>
                <td>{values.season}</td>
                <td className="text-start">{`Unmilled`}</td>
                <td className="text-start">
                    <TextFieldIcon 
                        name="qty_1"
                        type="number"
                        handleChange={handleChange} 
                        handleBlur={handleBlur}
                        value={values.qty_1}
                        label="Qty"
                        disabled={false}
                        required={true}
                        question="Quantity"
                    />
                </td>
                <td className="text-start">
                    <TextFieldIcon 
                        name="rate_1"
                        type="number"
                        handleChange={handleChange} 
                        handleBlur={handleBlur}
                        value={values.rate_1}
                        label="Rate"
                        disabled={false}
                        required={true}
                        question="Rate"
                    />
                </td>
                <td className="text-start">
                    <TextFieldIcon 
                        name="amount_1"
                        type="number"
                        handleChange={handleChange} 
                        handleBlur={handleBlur}
                        value={ parseFloat( values.qty_1 ) * parseFloat( values.rate_1 )}
                        label="Amount(UGX)"
                        disabled={true}
                        required={true}
                        question="Amount"
                    />
                </td>
                </tr>
                <tr>
                <td>{values.season}</td>
                <td className="text-start">{`Milled`}</td>
                <td className="text-start">
                    <TextFieldIcon 
                        name="qty_2"
                        type="number"
                        handleChange={handleChange} 
                        handleBlur={handleBlur}
                        value={values.qty_2}
                        label="Qty"
                        disabled={false}
                        required={true}
                        question="Quantity"
                    />
                </td>
                <td className="text-start">
                    <TextFieldIcon 
                        name="rate_2"
                        type="number"
                        handleChange={handleChange} 
                        handleBlur={handleBlur}
                        value={values.rate_2}
                        label="Rate"
                        disabled={false}
                        required={true}
                        question="Rate"
                    />
                </td>
                <td className="text-start">
                    <TextFieldIcon 
                        name="amount_2"
                        type="number"
                        handleChange={handleChange} 
                        handleBlur={handleBlur}
                        value={parseFloat( values.rate_2 ) * parseFloat( values.qty_2 )}
                        label="Amount(UGX)"
                        disabled={true}
                        required={true}
                        question="Amount"
                    />
                </td>
                </tr>
              </tbody>
            </table>
        </div>
      </Panel>
    </Card>
  )
}
